import { Injectable } from '@angular/core';
import {
  FulfillmentFormConfigInterface,
  FulfillmentFormSubmissionApiService,
  FulfillmentFormSubmissionInterface,
  GetLatestFulfillmentFormSubmissionRequest,
  GetLatestFulfillmentFormSubmissionResponseInterface,
} from '@vendasta/order-fulfillment';
import {
  FulfillmentOrderConfigApiService,
  ReleaseType,
  GetFulfillmentOrderConfigRequest,
} from '@vendasta/marketplace-apps';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderFormConfigService {
  constructor(
    private formSubmissionService: FulfillmentFormSubmissionApiService,
    private formConfigService: FulfillmentOrderConfigApiService,
  ) {}
  getFormConfig(salesOrderId: string, appId: string, businessId: string): Observable<FulfillmentFormConfigInterface> {
    return this.formSubmissionService
      .getLatestFulfillmentFormSubmission(
        new GetLatestFulfillmentFormSubmissionRequest({
          salesOrderId: salesOrderId,
          appId: appId,
          businessId: businessId,
        }),
      )
      .pipe(
        map((response) => response.fulfillmentFormSubmission.formConfig),
        catchError((err) => {
          if (err.status === 404) {
            return this.formConfigService
              .getFulfillmentOrderConfig(
                new GetFulfillmentOrderConfigRequest({
                  appId: appId,
                  release: ReleaseType.RELEASE_TYPE_PUBLISHED,
                  projectionFilter: { includeFormConfig: true },
                }),
              )
              .pipe(map((response) => response.config?.fulfillmentForm as FulfillmentFormConfigInterface));
          } else {
            throw err;
          }
        }),
      );
  }

  getLatestSubmission(
    salesOrderId: string,
    appId: string,
    businessId: string,
  ): Observable<FulfillmentFormSubmissionInterface> {
    return this.formSubmissionService
      .getLatestFulfillmentFormSubmission(
        new GetLatestFulfillmentFormSubmissionRequest({
          salesOrderId: salesOrderId,
          appId: appId,
          businessId: businessId,
        }),
      )
      .pipe(
        catchError(() => of({} as GetLatestFulfillmentFormSubmissionResponseInterface)),
        map((resp) => resp?.fulfillmentFormSubmission || {}),
      );
  }
}
